class AbstractAnnotations {

    constructor() {
        this.annotations = {};
        this.annotationTypes = [];
    }

    getAnnotations() {
        return this.annotations;
    }

    getAnnotationTypes() {
        return this.annotationTypes;
    }

    //assign key/value mapping
    setAnnotations(data) {
        let source  = data.source;
        let key = Object.keys(data)[0];
        let value =  Object.values(data)[0];
        this.annotations[key] = value;
    }


}

export default AbstractAnnotations